module.exports = __webpack_public_path__ + "img/4.13e12581.svg";